import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { BillingMethod } from '../../models/business/PolicyShift'
import { BILLING_METHODS_URL } from '../../utils/urls'

const fetchBillingMethods = (params: TableParams) =>
  SBAPI.FetchPaginated<BillingMethod[]>(BILLING_METHODS_URL, params)

const fetchBillingMethodById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<BillingMethod>(`${BILLING_METHODS_URL}/${id}`, params)

const createBillingMethod = (billingMethod: BillingMethod) =>
  SBAPI.Post(BILLING_METHODS_URL, billingMethod)

const updateBillingMethod = (billingMethod: BillingMethod) =>
  SBAPI.Put(`${BILLING_METHODS_URL}/${billingMethod.id}`, billingMethod)

const deleteBillingMethod = (billingMethod: BillingMethod) =>
  SBAPI.Delete(`${BILLING_METHODS_URL}/${billingMethod.id}`)

export {
  createBillingMethod,
  deleteBillingMethod,
  fetchBillingMethodById,
  fetchBillingMethods,
  updateBillingMethod,
}
